import React, {useState, useEffect} from 'react'
import './DocsSidebar.css'
import logo from './../../Assets/Vector_black.png'

function DocsSidebar({isVisible}) {


    return (
        <div id='docs_sidebar'>
            <div className='docs_logo_container'>
                <img src={logo} />
            </div>
            <div className='docs_title_container'>
                <h1>SheildScan API</h1>
            </div>
            <div className={isVisible == "introduction" ? 'docs_topics docs_topics_active' : 'docs_topics'}>
                <a href="#introduction" data-title="👋  Introduction">👋  Introduction</a>
            </div>
            <div className={isVisible == "developer-support" ? 'docs_topics docs_topics_active' : 'docs_topics'}>
                <a href="#developer-support" data-title="👩‍🏫 Developer Support">👩‍🏫 Developer Support</a>
            </div>
            <div className={isVisible == "authentication" ? 'docs_topics docs_topics_active' : 'docs_topics'}>
                <a href="#authentication" data-title="🔑 Authentication">🔑 Authentication</a>
            </div>
            <div className={isVisible == "ratelimits" ? 'docs_topics docs_topics_active' : 'docs_topics'}>
                <a href="#rate-limiting" data-title="🚦 Rate Limiting">🚦 Rate Limiting</a>
            </div>
            <div className='docs_topics'>
                <a href="#endpoints" data-title="🎯 Endpoints">🎯 Endpoints</a>
            </div>
            <div className='docs_topics'>
                <a href="#testing" data-title="🧪 Testing">🧪 Testing</a>
            </div>
            <div className='docs_topics'>
                <a href="#tips" data-title="💡 Tips">💡 Tips</a>
            </div>
            <div className='docs_topics'>
                <a href="#errors" data-title="🚨 Errors">🚨 Errors</a>
            </div>
            <div className='docs_api_keys'>
                <a href="#apikeys" data-title="Get your API Key via Dashboard">Get your API Key via Dashboard</a>
            </div>
            <div className='docs_back_page'>
                <a href="/" data-title="⬅ Back to OOPSpam">⬅ Back to SheildScan</a>
            </div>
        </div>
    )
}

export default DocsSidebar
